import { useEffect, useRef, useState } from 'react';

import { useWindowSize } from 'app/shared/hooks/useWindowSize';

export function useTerminationPreviewModal() {
  const scaleWrapperRef = useRef<HTMLDivElement>(null);
  const documentRef = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState<number>(1);
  const [width, height] = useWindowSize();

  const adjustScale = () => {
    if (documentRef.current === null || scaleWrapperRef.current === null) {
      return;
    }

    const scaleValue = Math.min(
      scaleWrapperRef.current.clientWidth / documentRef.current.clientWidth,
      scaleWrapperRef.current.clientHeight / documentRef.current.clientHeight
    );

    setScale(scaleValue);
  };

  useEffect(adjustScale, [width, height]);

  return {
    scaleWrapperRef,
    documentRef,
    scale,
  };
}
